import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=67d8d432&scoped=true"
import script from "./Batches.vue?vue&type=script&lang=ts"
export * from "./Batches.vue?vue&type=script&lang=ts"
import style0 from "./Batches.vue?vue&type=style&index=0&id=67d8d432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8d432",
  null
  
)

export default component.exports